import Spinners from "components/Shared/Spinners"
import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router-dom"
import { Container, Row } from "reactstrap"
import { getPrivacyPolicy } from "store/actions/globalSettingAction"

const AppPrivacyPolicy = () => {
  const dispatch = useDispatch()
  const { lang } = useParams()

  const { loading, privacyPolicy } = useSelector(state => state.GlobalSettings)

  useEffect(() => {
    const fetchPrivacyPolicy = () => {
      dispatch(getPrivacyPolicy())
    }
    fetchPrivacyPolicy()
  }, [lang])

  const content =
    lang === "sa" ? privacyPolicy?.descriptionAr : privacyPolicy?.description

  if (loading) return <Spinners />

  return (
    <React.Fragment>
      <div className="frutiger_font app_content">
        <Container>
          <Row className="my-3" dir={lang === "sa" ? "rtl" : "ltr"}>
            <div dangerouslySetInnerHTML={{ __html: content }} />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default AppPrivacyPolicy
